module.exports = __webpack_public_path__ + "img/mir.60b69d48.svg";